var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { height: "100%", hover: "" } },
    [
      _vm.edit
        ? _c(
            "v-flex",
            [
              _c(
                "v-form",
                { ref: "form", attrs: { "lazy-validation": "" } },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "subheading font-weight-bold" },
                    [
                      _c(
                        "v-flex",
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Field Name",
                              "single-line": "",
                              required: "",
                              rules: _vm.requiredRules
                            },
                            model: {
                              value: _vm.data_items.fieldName,
                              callback: function($$v) {
                                _vm.$set(_vm.data_items, "fieldName", $$v)
                              },
                              expression: "data_items.fieldName"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        [
                          _c(
                            "v-layout",
                            {
                              attrs: { "align-center": "", "justify-end": "" }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-1",
                                  on: { click: _vm.deleteThis }
                                },
                                [_vm._v("close\n          ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-1",
                                  on: { click: _vm.saveThis }
                                },
                                [_vm._v("save\n          ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs3: "" } },
                            [
                              _c("v-list-tile-content", [
                                _vm._v("Description:")
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs9: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Description",
                                  "single-line": "",
                                  required: "",
                                  rules: _vm.requiredRules
                                },
                                model: {
                                  value: _vm.data_items.description,
                                  callback: function($$v) {
                                    _vm.$set(_vm.data_items, "description", $$v)
                                  },
                                  expression: "data_items.description"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs3: "" } },
                            [_c("v-list-tile-content", [_vm._v("Service:")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs9: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Service",
                                  "single-line": "",
                                  required: "",
                                  rules: _vm.requiredRules
                                },
                                model: {
                                  value: _vm.data_items.service,
                                  callback: function($$v) {
                                    _vm.$set(_vm.data_items, "service", $$v)
                                  },
                                  expression: "data_items.service"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs3: "" } },
                            [_c("v-list-tile-content", [_vm._v("Type:")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs9: "" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.types,
                                  label: "Type",
                                  "single-line": "",
                                  required: "",
                                  rules: _vm.requiredRules
                                },
                                model: {
                                  value: _vm.data_items.type,
                                  callback: function($$v) {
                                    _vm.$set(_vm.data_items, "type", $$v)
                                  },
                                  expression: "data_items.type"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.data_items.type === "string"
                        ? _c(
                            "v-flex",
                            [
                              _c(
                                "v-list-tile",
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs3: "" } },
                                    [
                                      _c("v-list-tile-content", [
                                        _vm._v("Values:")
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs9: "" } },
                                    [
                                      _c(
                                        "v-list-tile-content",
                                        { staticClass: "align-end" },
                                        [
                                          _c("v-combobox", {
                                            attrs: {
                                              multiple: "",
                                              "small-chips": "",
                                              "deletable-chips": "",
                                              "hide-no-data": "",
                                              "single-line": "",
                                              clearable: "",
                                              "allow-overflow": false,
                                              label: "type possible values here"
                                            },
                                            model: {
                                              value: _vm.data_items.values,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.data_items,
                                                  "values",
                                                  $$v
                                                )
                                              },
                                              expression: "data_items.values"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm.data_items.type === "scale"
                        ? _c(
                            "v-flex",
                            [
                              _c(
                                "v-list-tile",
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs3: "" } },
                                    [
                                      _c("v-list-tile-content", [
                                        _vm._v("Interval:")
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs9: "" } },
                                    [
                                      _c(
                                        "v-list-tile-content",
                                        { staticClass: "align-end" },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Scale [min-max]",
                                              "single-line": "",
                                              mask: _vm.scaleMask,
                                              "return-masked-value": "",
                                              required: "",
                                              rules: _vm.requiredRules
                                            },
                                            model: {
                                              value: _vm.data_items.scale,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.data_items,
                                                  "scale",
                                                  $$v
                                                )
                                              },
                                              expression: "data_items.scale"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "v-flex",
            { on: { dblclick: _vm.editThis } },
            [
              _c(
                "v-card-title",
                { staticClass: "subheading font-weight-bold" },
                [
                  _vm._v(_vm._s(_vm.data_items.fieldName) + "\n      "),
                  _c(
                    "v-layout",
                    { attrs: { "align-center": "", "justify-end": "" } },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-1", on: { click: _vm.editThis } },
                        [_vm._v("edit\n        ")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-list",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-list-tile",
                    [
                      _c("v-list-tile-content", [_vm._v("Description:")]),
                      _vm._v(" "),
                      _c("v-list-tile-content", { staticClass: "align-end" }, [
                        _vm._v(_vm._s(_vm.data_items.description))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile",
                    [
                      _c("v-list-tile-content", [_vm._v("Service:")]),
                      _vm._v(" "),
                      _c("v-list-tile-content", { staticClass: "align-end" }, [
                        _vm._v(_vm._s(_vm.data_items.service))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile",
                    [
                      _c("v-list-tile-content", [_vm._v("Type:")]),
                      _vm._v(" "),
                      _c("v-list-tile-content", { staticClass: "align-end" }, [
                        _vm._v(_vm._s(_vm.data_items.type))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.data_items.type === "string"
                    ? _c(
                        "v-flex",
                        [
                          _c(
                            "v-list-tile",
                            [
                              _c("v-list-tile-content", [_vm._v("Values:")]),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                { staticClass: "align-end" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(this.valuesArray) +
                                      "\n          "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm.data_items.type === "scale"
                    ? _c(
                        "v-flex",
                        [
                          _c(
                            "v-list-tile",
                            [
                              _c("v-list-tile-content", [_vm._v("Interval:")]),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                { staticClass: "align-end" },
                                [_vm._v(_vm._s(_vm.data_items.scale))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm.data_items.type === "boolean"
                    ? _c(
                        "v-flex",
                        [
                          _c(
                            "v-list-tile",
                            [
                              _c("v-list-tile-content", [_vm._v("Values:")]),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                { staticClass: "align-end" },
                                [_vm._v("true, false")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "v-flex",
                        [
                          _c(
                            "v-list-tile",
                            [
                              _c("v-list-tile-content", [_vm._v("Values:")]),
                              _vm._v(" "),
                              _c("v-list-tile-content", {
                                staticClass: "align-end"
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-924b7c58", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-924b7c58","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-class/userClassCard.vue
// module id = null
// module chunks = 